import React from 'react';
import { Paper, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { styled } from '@mui/material/styles';
import { motion } from 'framer-motion';

export const DashboardPaper = styled((props) => <Paper elevation={0} {...props} />)(({ theme }) => ({
  borderRadius: 15,
  backgroundColor: theme.palette.background.paper,
  color: theme.palette.text.primary,
  border: `1px solid ${theme.palette.divider}`,
}));

const MotionPaper = motion(Paper);

export const MotionDashboardPaper = styled((props) => <MotionPaper elevation={0} {...props} />)(({ theme }) => ({
  borderRadius: 15,
  backgroundColor: theme.palette.background.paper,
  color: theme.palette.text.primary,
  border: `1px solid ${theme.palette.divider}`,
}));

export const MotionGrid = motion(Grid);

export const TotalNumberText = styled(Typography)`
  font-size: 55px;
  font-weight: bold;
`;

export const AgentStatusChart = styled('div')`
  width: 100%;
  height: 15rem;
  margin-left: auto;
  margin-right: auto;
`;

export const StatusContainer = styled(motion.div)`
  font-size: 1em;
  position: relative;
  width: 81% !important;
  border-radius: 20px;
  padding: 7%;
  justify-content: center;
  cursor: default;
  color: ${(props) => props.color};
  background-color: ${(props) => props.background};
  text-align: center;
`;

export const LastUpdateText = styled(Typography)`
        font-size: 1em;
        cursor: default;
        text-align: left;
        margin-left: 0.5rem !important;
`;
